module.exports = __webpack_public_path__ + "img/trustpilot_rating.16ff808c.svg";